<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <v-menu
            bottom
            origin="center center"
            transition="scale-transition"
    >
        <template v-slot:activator="{ on }">
            <v-btn text dark class="hidden-sm-and-down" v-on="on">
                {{ $t('orderProducts') }}
            </v-btn>
            <v-btn icon dark class="hidden-md-and-up" v-on="on">
                <v-icon>info</v-icon>
            </v-btn>
        </template>
        <v-card width="300px">
            <v-simple-table>
                <template v-slot:default>
                    <thead>
                        <tr>
                            <th class="text-left">{{ $t('name') }}</th>
                            <th class="text-left px-0">{{ $t('sum') }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="item in products" :key="item.productId">
                            <td class="caption">{{ item.productName }}</td>
                            <td class="caption text--main-yellow px-0">{{ item.calculatedPrice }} {{ item.price.currency.toUpperCase() }}</td>
                        </tr>
                        <tr>
                            <td class="subtitle-2">{{ $t('total') }}:</td>
                            <td class="subtitle-2 text--main-yellow px-0">
                                <div v-for="price in totalPrice" :key="price[0]">
                                    {{ price[1] }} {{ price[0] }}
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </template>
            </v-simple-table>
        </v-card>
    </v-menu>
</template>

<script>
    export default {
        name: "OrderDialogProducts",
        props: [],
        computed: {
            productIds() {
                return this.$store.state.order.products;
            },
            products() {
                const ids = this.productIds;

                return this.storeBasketItems.filter(item => ids.indexOf(item.productId) > - 1)
            },
            storeBasketItems() {
                return this.$store.state.basket.items;
            },
            totalPrice() {
                const price = {};

                this.products.map(item => {
                    let key = item.price.currency.toUpperCase();

                    if(!price[key]) {
                        price[key] = item.calculatedPrice;
                    } else {
                        price[key] += item.calculatedPrice;
                    }
                });

                return Object.entries(price);
            }
        }
    }
</script>

<style scoped>

</style>
